export default __webpack_public_path__ + "static/sanjayRakesh2-7ffa10f1cf5b92816e9f684e7559dce5.jpg";